import { Card, Icon } from "@fanduel/og-fe-library";
import cx from "classnames";
import { useState, useCallback } from "react";
import styles from "./trackListControls.module.scss";

interface SearchControlProps {
  setSearchTerm: (input: string) => void;
}
interface SearchEvent {
  preventDefault: () => void;
}

const SearchControl = ({ setSearchTerm }: SearchControlProps) => {
  const [tempSearchTerm, setTempSearchTerm] = useState("");
  const [focused, setFocus] = useState(false);

  const search = useCallback(
    (e: SearchEvent) => {
      e.preventDefault();
      setSearchTerm(tempSearchTerm);
    },
    [tempSearchTerm, setSearchTerm]
  );

  const clearForm = () => {
    setSearchTerm("");
    setTempSearchTerm("");
  };
  return (
    <Card
      variant="elevation"
      elevation="mid"
      className={styles.searchContainer}
    >
      <form onSubmit={search}>
        <div className={cx(styles.searchBox, focused && styles.focused)}>
          <Icon
            iconName="icons.search"
            iconSize={17}
            iconColor="colorBaseGreyDarken1"
          />
          <input
            onFocus={() => setFocus(true)}
            onBlur={() => setFocus(false)}
            onChange={(e) => setTempSearchTerm(e.target.value)}
            value={tempSearchTerm}
            type="text"
            placeholder="What are you looking for?"
          />
          <input
            type="reset"
            name="reset"
            data-testid="reset-btn"
            value="X"
            alt="Clear the search form"
            onClick={clearForm}
            disabled={tempSearchTerm.length === 0}
          />
          <button
            data-testid="searchTerms"
            className={cx(focused && styles.focused)}
            onClick={search}
            type="button"
          >
            Search
          </button>
        </div>
      </form>
    </Card>
  );
};

export default SearchControl;
